import React, {Component} from 'react'
import './index.less'

interface RefundTypeProps {
    type: string
    onClick?: ()=>void
}

export default class RefundType extends Component<RefundTypeProps> {
    render() {
        return(
            <div className='refund-type' onClick={this.props.onClick}>
                <span className='refund-type-title'>申请原因</span>
                <div>
                    <span className='refund-type-brief'>{this.props.type}</span>
                    <img className='refund-type-img' src="/public/assets/img/arrowDown.png" alt=">"/>
                </div>
            </div>
        )
    }
}